<template>
	<div>
		<section
			class="section pb-0 section-components"
			id="register"
			v-if="!confirmacion"
		>
			<div
				class="mb-5 container-fluid text-center"
				v-if="customer_id == '' && !fase"
			>
				<!-- Inputs -->
				<h1 id="register_form" class="mb-4" style="color: #000">
					<b>¡Participa y Gana con Mobil</b><sup>™</sup><b>!</b>
				</h1>
				<h6 style="color: #000">
					Concurso digital basado en conocimientos, habilidad y/o destreza.
				</h6>
				<br />
				<div class="mt-4 container">
					<b style="color: #000">
						Si cargaste $300 o más de cualquier combustible en una de las
						estaciones de servicio Mobil<sup>™</sup>
						participantes,<br />registra tu ticket de compra y participa para
						ganar UN BOLETO DOBLE para el GRAN PREMIO F1 DE LA CIUDAD DE MÉXICO
						2021.
					</b>
				</div>
				<form
					@submit="checkForm"
					method="post"
					novalidate="true"
					enctype="multipart/form-data"
				>
                    <div class="container">
					<div class="row justify-content-center">
						<div
							class="card shadow-sm mt-5 col-12 col-md-12 col-lg-6"
							style="border: 2px solid #ee2a32"
						>
							<div class="card-body">
								<p style="color: #000">
									Registra tu ticket y responde las preguntas
								</p>
								<div class="row mt-5">
									<div class="col-lg-3 text-left">
										<label for="ticket_date" style="color: #000" class="mt-2"
											>Fecha:</label
										>
									</div>
									<div class="col-lg-6 text-left">
										<div class="form-group">
											<input
												type="date"
												class="form-control"
												v-model="formTicket.ticket_date"
												:max="exh"
												required
												placeholder="DD/MM/YYYY"
											/>
											<!-- <datepicker   :disabledDates="disabledDates" :language="languages[language]" format="dd/MM/yyyy" id="ticket_date" name="ticket_date" v-model="formTicket.ticket_date" placeholder="DD/MM/YYYY" value="" required input-class="form-control"></datepicker> -->
											<small class="help-block" v-if="errorFecha"
												>La fecha es obligatoria</small
											>
											<br />
											<small
												class="help-block"
												zone="America/Mexico_City"
												v-if="errorHora"
												>La hora es obligatoria</small
											>
										</div>
									</div>
									<div class="col-lg-3">
										<div class="form-group">
											<datetime
												type="time"
												id="ticket_hour"
												name="ticket_hour"
												v-model="formTicket.ticket_hour"
												placeholder="00:00"
												value=""
												required
												input-class="form-control"
												:phrases="{ ok: 'Continuar', cancel: 'Salir' }"
												use12-hour
												auto
											></datetime>
											<!-- <small class="help-block" zone="America/Mexico_City" v-if="errorHora">La hora es obligatoria</small> -->
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-lg-3 text-left">
										<label
											for="full_name"
											style="color: #000"
											class="mt-2"
											v-if="!isMobile"
											>Nombre:</label
										>
									</div>
									<div class="col-lg-9 text-left">
										<div class="form-group">
											<input
												type="text"
												class="form-control"
												id="full_name"
												name="full_name"
												v-model="formTicket.full_name"
												placeholder="Nombre y Apellido"
												value=""
												required
											/>
											<small class="help-block" v-if="errorNombre"
												>El nombre es obligatorio</small
											>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-lg-3 text-left">
										<label
											for="full_name"
											style="color: #000"
											class="mt-2"
											v-if="!isMobile"
											>Estado:</label
										>
									</div>
									<div class="col-lg-9 text-left">
										<div class="form-group">
											<select
												class="form-control"
												id="estado"
												name="estado"
												v-model="formTicket.estado"
												placeholder="Estado"
												required
											>
												<option value="">Seleccione un Estado</option>
												<option label="Aguascalientes" value="Aguascalientes">
													Aguascalientes
												</option>
												<option label="Baja California" value="Baja California">
													Baja California
												</option>
												<option label="Durango" value="Durango">Durango</option>
												<option
													label="Estado de México"
													value="Estado de México"
												>
													Estado de México
												</option>
												<option label="Guanajuato" value="Guanajuato">
													Guanajuato
												</option>
												<option label="Hidalgo" value="Hidalgo">Hidalgo</option>
												<option label="Jalisco" value="Jalisco">Jalisco</option>
												<option label="Michoacán" value="Michoacán">
													Michoacán
												</option>
												<option label="Nuevo León" value="Nuevo León">
													Nuevo León
												</option>
												<option label="Querétaro" value="Querétaro">
													Querétaro
												</option>
												<option label="Quintana Roo" value="Quintana Roo">
													Quintana Roo
												</option>
												<option label="Torreón" value="Torreón">Torreón</option>
												<option label="Zacatecas" value="Zacatecas">
													Zacatecas
												</option>
											</select>
											<small class="help-block" v-if="errorEstado"
												>El estado es obligatorio.</small
											>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-lg-3 text-left">
										<label
											for="email"
											style="color: #000"
											class="mt-2"
											v-if="!isMobile"
											>Email:</label
										>
									</div>
									<div class="col-lg-9 text-left">
										<div class="form-group">
											<input
												type="text"
												class="form-control"
												id="email"
												name="email"
												v-model="formTicket.email"
												placeholder="Email"
												value=""
												required
											/>
											<small class="help-block" v-if="errorCorreo"
												>El correo es obligatorio</small
											>
											<small class="help-block" v-if="errorCorreoValido"
												>El correo no es valido</small
											>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-lg-3 text-left">
										<label
											for="phone"
											style="color: #000"
											class="mt-2"
											v-if="!isMobile"
											>Celular:</label
										>
									</div>
									<div class="col-lg-9 text-left">
										<div class="form-group">
											<input
												type="text"
												class="form-control"
												id="phone"
												name="phone"
												v-model="formTicket.phone"
												placeholder="Celular"
												value=""
												required
											/>
											<small class="help-block" v-if="errorCelular"
												>El celular es obligatorio</small
											>
											<small class="help-block" v-if="errorCelularValido"
												>El número de celular no es valido.</small
											>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-lg-3 text-left">
										<label
											for="phone"
											style="color: #000"
											class="mt-2"
											v-if="!isMobile"
											>Monto de compra:</label
										>
									</div>
									<div class="col-lg-9 text-left">
										<div class="form-group">
											<input
												type="text"
												class="form-control"
												id="monto"
												name="monto"
												v-model="formTicket.monto"
												placeholder="Monto de compra"
												value=""
												required
											/>
											<small class="help-block" v-if="errorMonto"
												>El monto es obligatorio.</small
											>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-lg-3 text-left">
										<label
											for="billing_code"
											style="color: #000"
											class="mt-2"
											v-if="!isMobile"
											>Ticket:</label
										>
									</div>
									<div class="col-lg-7 text-left">
										<div class="form-group">
											<input
												type="text"
												class="form-control"
												id="billing_code"
												name="billing_code"
												v-model="formTicket.billing_code"
												placeholder="Folio del Ticket"
												value=""
												required
											/>
											<small class="help-block" v-if="errorTicket"
												>El folio del Ticket es requerido.</small
											>
											<small class="help-block" v-if="errorTicketExist">{{
												errorTicketExistTxt
											}}</small>
											<br />
											<small class="help-block" v-if="errorImage"
												>Fotografía del Ticket es requerida</small
											>
										</div>
									</div>
									<div class="col-lg-2">
										<label class="custom-file-upload">
											<input type="file" @change="onFileChange" />
											<img
												v-if="!formTicket.image"
												:src="require('@/assets/img/camara.png')"
												alt=""
												style="width: 35px !important; cursor: pointer"
											/>
											<img
												v-else
												:src="require('@/assets/img/check.png')"
												alt=""
												style="width: 35px !important; cursor: pointer"
											/>
										</label>
										<!-- <input type="hidden" id="image" name="image" v-model="formTicket.image" required>
                                    <img src="https://mobilracing.mx/img/camara.png" alt="" style="width:50px!important; cursor:pointer;"> -->
									</div>
								</div>
								<!-- <small class="text-danger">{{errorImgs}}</small> <br>
                                <small class="text-danger">{{errorArchivo}}</small> <br> -->
							</div>
						</div>
					</div>
                    </div>
					<div class="row justify-content-center">
						<div
							class="col-md-4 custom-control custom-checkbox mt-2 text-right"
						>
							<input
								type="checkbox"
								class="custom-control-input"
								id="term_acept"
								name="term_acept"
								@change="check($event)"
								v-model="term_acept"
								:value="term_acept_val"
							/>
							<label
								class="custom-control-label"
								for="term_acept"
								style="color: #000"
								>He leído y acepto los términos y condiciones.</label
							>
							<br />
							<small class="help-block text-left" v-if="errorTermAcept"
								>Debe aceptar los términos y condiciones</small
							>
						</div>
						<div class="col-md-12">
							<button
								style="background: #007bff"
								type="submit"
								class="btn btn-primary p-1 mt-5 mb-4 pl-5 pr-5"
								id="enviar"
							>
								Enviar
								<b-spinner small v-if="loader"></b-spinner>
							</button>
						</div>
						<div class="col-md-3 mt-45">
							<hr style="border-top: 2px solid #f5f5f5 !important" />
						</div>
					</div>
				</form>
			</div>
			<div
				class="mb-5 container-fluid text-center"
				v-else-if="customer_id && fase == 1 && !confirmacion"
			>
				<div id="registro_exitoso" class="row justify-content-md-center">
					<div class="col-md-6">
						<center>
							<div class="shadow-lg p-3 mb-5 bg-white text-center">
								<img
									:src="require('@/assets/img/check.png')"
									alt=""
									id="checkImage2"
								/>
								<h5 class="mt-4" style="color: #000">
									<strong>Registro exitoso</strong>
								</h5>
								<h6 class="mt-4" style="color: #000; font-size: small">
									Hemos enviado un código de confirmación al correo que
									registraste. <br v-if="!isMobile" />
									Para seguir participando por favor ingresa el código y
									confirma.
								</h6>
								<center>
									<input
										type="text"
										class="form-control mt-4"
										placeholder="Código de confirmación"
										v-model="codigo"
										:style="!isMobile ? 'width: 50%;' : ''"
									/>
									<small class="help-block" v-if="errorCodigo">{{
										mensajeCodigo
									}}</small>
									<h6 class="mt-2" style="color: #000; font-size: small">
										No recibí código.
										<b
											style="cursor: pointer; color: #00579e"
											@click="reenviarCorreo()"
											>Reenviar correo</b
										>
									</h6>
									<h6 v-if="reenviado" style="color: #00579e; font-size: small">
										Correo reenviado correctamente
									</h6>
									<div class="text-center">
										Si no recibiste el correo electrónico, revisa en tu bandeja de SPAM.
									</div>
								</center>

								<button
									style="background: #007bff"
									type="button"
									class="btn btn-primary p-1 mt-4 mb-4 pl-5 pr-5"
									id="enviar"
									@click="confirmarUser()"
								>
									Confirmar
									<b-spinner small v-if="loader"></b-spinner>
								</button>
							</div>
						</center>
					</div>
				</div>
			</div>
		</section>
		<template v-if="confirmacion">
			<Confirmacion :customer="customer_id"></Confirmacion>
		</template>
	</div>
</template>
<script>
import $ from "jquery";
import Confirmacion from "./Confirmacion";
import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import * as lang from "vuejs-datepicker/src/locale";
import axios from "axios";
import VueAxios from "vue-axios";
import moment from "moment";
const state = {
	date: new Date(),
};
export default {
	components: {
		Datepicker,
		datetime: Datetime,
		Confirmacion,
	},
	data() {
		return {
			time: "",
			errorTicketExistTxt: "",
			errors: [],
			errorFecha: false,
			errorHora: false,
			errorNombre: false,
			errorCorreo: false,
			errorCorreoValido: false,
			errorCelular: false,
			errorCelularValido: false,
			errorTicket: false,
			errorTicketExist: false,
			errorTermAcept: false,
			errorEstado: false,
			errorMonto: false,
			formTicket: {
				ticket_date: null,
				ticket_hour: null,
				full_name: null,
				email: null,
				phone: null,
				billing_code: null,
				image: null,
				monto: "",
				estado: "",
			},
			exh: moment().format("YYYY-MM-DD"),
			term_acept: 0,
			term_acept_val: 0,
			format: "dd/MM/yyyy",
			customer_id: "",
			disabledDates: {
				from: new Date(),
			},
			disabledFn: {
				customPredictor(date) {
					if (date.getDate() % 3 === 0) {
						return true;
					}
				},
			},
			eventMsg: null,
			state: state,
			language: "es",
			languages: lang,
			loader: false,
			isMobile: this.$mobile(),
			imagenMin1: "",
			errorImage: false,
			confirmacion: 0,
			fase: 0,
			codigo: "",
			errorCodigo: 0,
			mensajeCodigo: "",
			reenviado: 0,
		};
	},
	mounted() {
		// this.$emit('segundaEtapa')
	},
	methods: {
		checkForm: function (e) {
			e.preventDefault();
			this.errors = [];
			this.errorFecha = false;
			this.errorHora = false;
			this.errorNombre = false;
			this.errorCorreo = false;
			this.errorCorreoValido = false;
			this.errorCelular = false;
			this.errorCelularValido = false;
			this.errorTicket = false;
			this.errorTicketExist = false;
			this.errorTicketExistTxt = "";
			this.errorTermAcept = false;
			this.customer_id = "";
			this.errorMonto = false;
			this.errorEstado = false;
			this.errorImage = false;
			if (!this.formTicket.ticket_date) {
				this.errorFecha = true;
				this.errors.push("La fecha es obligatoria.");
			}
			if (!this.formTicket.ticket_hour) {
				this.errorHora = true;
				this.errors.push("La hora es obligatoria.");
			}
			if (!this.formTicket.full_name) {
				this.errorNombre = true;
				this.errors.push("El nombre es obligatoria.");
			}
			if (!this.formTicket.phone) {
				this.errorCelular = true;
				this.errors.push("El celular es obligatoria.");
			} else if (!this.validPhone(this.formTicket.phone)) {
				this.errorCelularValido = true;
				this.errors.push("El número de celular no es valido.");
			}
			if (!this.formTicket.billing_code) {
				this.errorTicket = true;
				this.errors.push("El folio del Ticket es requerido.");
			}
			if (!this.formTicket.estado) {
				this.errorEstado = true;
				this.errors.push("El estado es obligatorio.");
			}
			if (!this.formTicket.monto) {
				this.errorMonto = true;
				this.errors.push("El monto es obligatorio.");
			}

			if (!this.formTicket.email) {
				this.errorCorreo = true;
				this.errors.push("El correo electrónico es obligatorio.");
			} else if (!this.validEmail(this.formTicket.email)) {
				this.errorCorreoValido = true;
				this.errors.push("El correo electrónico debe ser válido.");
			}
			if (!this.term_acept) {
				this.errorTermAcept = true;
				this.errors.push("Debe aceptar los terminos y condiciones.");
			}
			if (!this.formTicket.image) {
				this.errorImage = true;
				this.errors.push("Tome fotografía al ticket.");
			}
			if (!this.errors.length) {
				this.loader = true;
				// Acción si todo esta correcto
				// axios.get("http://127.0.0.1:8000/api/api_save_customer").then((rest) => {

				// });
				let model = this.prepareModel();

				axios
					.post(this.$root.$urlApi+"api_save_customer", model)
					.then(({ data }) => {
						this.fase = 1;
						this.customer_id = data.customer_id;
						this.$emit('segundaEtapa')
						this.loader = false;
						this.confirmacion = data.existe;
						setTimeout(() => {
							this.$scrollTo('#registro_exitoso', 800, {
								offset: -100,
							});
						}, 500);
					})
					.catch((err) => {
						if (err.response.status === 404) {
							if (!err.response.data.ticket) {
								this.errorTicketExist = true;
								this.errorTicketExistTxt = err.response.data.menssage;
								this.errors.push(err.response.data.menssage);
								this.loader = false;
							}
						}
					});
			}
		},
		prepareModel() {
			var model = new FormData();
			model.append("billing_code", this.formTicket.billing_code);
			model.append("email", this.formTicket.email);
			model.append("estado", this.formTicket.estado);
			model.append("full_name", this.formTicket.full_name);
			model.append("image", this.formTicket.image);
			model.append("monto", this.formTicket.monto);
			model.append("phone", this.formTicket.phone);
			model.append("ticket_date", this.formTicket.ticket_date);
			model.append("ticket_hour", this.formTicket.ticket_hour);

			return model;
		},
		validEmail: function (email) {
			var re =
				/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(email);
		},
		validPhone: function (phone) {
			var re = /^[0-9]{1}[0-9]{9}$/;
			return re.test(phone);
		},
		check(e) {
			this.term_acept_val = 0;
			if (this.term_acept) {
				this.term_acept_val = 1;
			}
		},
		onFileChange(event) {
			this.formTicket.image = event.target.files[0];
			//  this.model.banner1 = event.target.files[0];
			let reader = new FileReader();
			reader.onload = (e) => {
				this.imagenMin1 = e.target.result;
			};
			reader.readAsDataURL(this.formTicket.image);
		},
		confirmarUser() {
			this.loader = true;
			if (!this.codigo) {
				this.errorCodigo = 1;
				this.mensajeCodigo = "Código requerido";
				this.loader = false;
			} else {
				axios
					.get(
						this.$root.$urlApi+"confirmarcorreo/" +
							this.codigo +
							"/" +
							this.customer_id
					)
					.then(({ data }) => {
						console.log(data);
						this.confirmacion = data.confirma;
						this.loader = false;
						if (this.confirmacion == 0) {
							this.errorCodigo = 1;
							this.mensajeCodigo = "Código inválido";
						}
					});
			}
		},
		reenviarCorreo() {
			axios
				.get(
					this.$root.$urlApi+"reenviarcorreo/" + this.customer_id
				)
				.then(({ data }) => {
					console.log(data);
					this.reenviado = data.reenviado;
				});
		},
	},
	// mounted(){},
};
</script>
<style>
input[type="file"] {
	display: none;
}
.custom-file-upload {
	border: 1px solid #ccc;
	display: inline-block;
	padding: 6px 12px;
	cursor: pointer;
}
.help-block {
	color: red;
	text-align: left;
}

#checkImage2 {
	width: 11% !important;
}
</style>